import GokuDataGrid from '@/components/GokuDataGrid'
import SubHeaders from '@/components/Headers/SubHeaders'
import { IPermissionProps } from '@/types/shared'
import { paths } from '@/utils/path'
import React from 'react'
import { getHRContactSource } from '@/modules/Marketing/services'
import { contactHRSourceColumns } from './column'
const HRList: React.FC<IPermissionProps> = () => {
    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: paths.hrContact,
                        title: 'Contact HR',
                    },
                ]}
            />

            <GokuDataGrid
                apiCall={getHRContactSource}
                reactQueryKey={'contact-source-hr-list'}
                columns={contactHRSourceColumns}
                dataGridProps={{
                    getRowId: (row) => row?.contact_source_id,
                }}
                actions={[]}
                options={{
                    showHideColumn: false,
                    showSearch: false,
                    pageSize: 5,
                    title: '',
                }}
            ></GokuDataGrid>
        </div>
    )
}

export default HRList
